import { createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { Header } from './-header/-components';
import { TicketDetailOutletWithForm } from './_layout/-context/ticket-tab-form-context';
import { TicketFormStore } from './_layout/-store/store';

/**
 * 開発チケット 詳細画面の Layout。
 *
 * Issue 詳細の `_layout.tsx` と同じパターン。CForm / Zustand store /
 * TicketDetailOutletWithForm による section 単位編集を提供する。
 */
export const Route = createFileRoute('/_stacktrace/development-tickets/$ticketId/_layout')({
  component: Layout
});
function Layout() {
  const store = TicketFormStore.createStore();
  return <TicketFormStore.Provider value={store}>
      <VStack>
        <Header />
        <TicketDetailOutletWithForm />
      </VStack>
    </TicketFormStore.Provider>;
}